export const APPLICATION_ID = 'application_id'
